import { render, staticRenderFns } from "./CategoryTreeItem.vue?vue&type=template&id=18d78659&"
import script from "./CategoryTreeItem.vue?vue&type=script&lang=js&"
export * from "./CategoryTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTreeItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports